import { createSlice } from "@reduxjs/toolkit";

const initialState = () => ({
  issueDateStart: null,
  issueDateEnd: null,
  filters: {},
});

export const productsABCSlice = createSlice({
  name: "productsABC",
  initialState,
  reducers: {
    handleChangeDate: (state, { payload }) => {
      state.issueDateStart = payload.issueDateStart;
      state.issueDateEnd = payload.issueDateEnd;
    },
    handleAddFilter: (state, { payload }) => {
      state.filters = payload;
    },
    handleCleanFilters: state => {
      state.filters = {};
    },
  },
});

export const { handleChangeDate, handleAddFilter, handleCleanFilters } =
  productsABCSlice.actions;

export default productsABCSlice.reducer;
